import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useReducer, useEffect } from 'react';
import { useBiAction } from '../BiTracking';
import { FilterPicker } from '../FilterPicker';
import { RadioButtonWithLabel } from '../RadioButtonWithLabel';
import styles from './SingleSelectFilterPicker.module.scss';
import { createReducer, getInitialSelection } from './SingleSelectFilterPicker.reducer';
export function SingleSelectFilterPicker(props) {
    const { label, options, onChange, value, closeDelayMs, bi } = props;
    const logBiAction = useBiAction();
    const [state, dispatchAction] = useReducer(createReducer(), getInitialSelection());
    const isControlled = typeof value !== 'undefined';
    useEffect(()=>{
        if (isControlled) {
            let index;
            const option = options.find((optionObj, ObjIndex)=>{
                if (optionObj.value === value) {
                    index = ObjIndex;
                    return true;
                }
            });
            if (option && typeof index !== 'undefined') {
                dispatchAction({
                    //todo - don't re-dispatch if already selected
                    type: 'selectOption',
                    value: {
                        index
                    }
                });
                dispatchAction({
                    type: 'applyChanges',
                    label: option.label
                });
            }
        }
    }, [
        isControlled,
        value,
        options
    ]);
    return /*#__PURE__*/ _jsx(FilterPicker, {
        testId: props.testId,
        label: state.labelToDisplay || label,
        highlightTrigger: state.selectedOptionIndex !== 0,
        title: label,
        closeDelayMs: closeDelayMs,
        onApply: ()=>{
            if (state.selectedOptionIndex === state.previousState.selectedOptionIndex) return;
            const option = options[state.selectedOptionIndex];
            if (bi === null || bi === void 0 ? void 0 : bi.name) {
                var _props_testId;
                logBiAction({
                    entityType: 'single_select_filter_picker',
                    entityName: bi.name,
                    actionType: 'click',
                    data: _object_spread_props(_object_spread({}, bi.data), {
                        test_id: (_props_testId = props.testId) !== null && _props_testId !== void 0 ? _props_testId : '',
                        selected_value: option.label
                    })
                });
            }
            if (!isControlled) {
                dispatchAction({
                    type: 'applyChanges',
                    label: option.label
                });
            }
            onChange(option, state.selectedOptionIndex);
        },
        onClose: (opts)=>{
            if (opts === null || opts === void 0 ? void 0 : opts.revert) {
                dispatchAction({
                    type: 'revert'
                });
                if (isControlled) {
                    onChange();
                }
            }
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.radioGroup,
            children: options.map((option, index)=>{
                return /*#__PURE__*/ _jsx(RadioButtonWithLabel, {
                    // eslint-disable-next-line custom/no-hardcoded-nobi-in-seagull -- SingleSelectFilterPicker self-logs the option toggle as `single_select_filter_picker`/`select` in this onChange using the consumer's bi.name; a child bi would double-fire the same event
                    noBi: true,
                    testId: "".concat(props.testId, "-item-").concat(option.value),
                    label: option.label,
                    sublabel: option.counter ? "(".concat(option.counter, ")") : null,
                    checked: state.selectedOptionIndex === index,
                    onChange: ()=>{
                        if (bi === null || bi === void 0 ? void 0 : bi.name) {
                            var _props_testId;
                            logBiAction({
                                entityType: 'single_select_filter_picker',
                                entityName: bi.name,
                                actionType: 'select',
                                data: _object_spread_props(_object_spread({}, bi.data), {
                                    test_id: (_props_testId = props.testId) !== null && _props_testId !== void 0 ? _props_testId : '',
                                    selected_value: option.label
                                })
                            });
                        }
                        dispatchAction({
                            type: 'selectOption',
                            value: {
                                index
                            }
                        });
                    }
                }, option.value);
            })
        })
    });
}
